import React from 'react'

import Calendar from 'Components/Checkout/Calendar'
import cn from 'classnames'
import chk from 'Scss/pages/checkout.scss'
import cl from './DeliveryGroby.scss'
import cg from 'Scss/app.scss'
import btnCss from 'Components/Button/Button.scss'
import { DispatchProp, connect } from 'react-redux'
import { updateOrder, setCart } from 'Utils/redux/actions'
import { ShippingAddressForm } from 'Components/Profile/AddressListFoldableAddressForm'
import { ShippingAddressFragment, ShippingMethodFragment_ShippingMethodGRoby_data, updateCart, updateCartVariables, CartFragment, getCheckoutInfo_shippingMethods_ShippingMethodGRoby, CartFragment_shipping_address, CartShippingAddressInput } from 'Utils/api/gql/types'
import { noError, parseErrors, validateForm, hasErrors, collectAllErrorsForModal, hasFieldErrors } from 'Utils/helpers/errorHelper'
import Button from 'Components/Button'
import _app from 'Pages/_app'
import { updateCartMutation } from 'Utils/api/gql/mutations/updateCart'
import { convertShippingAddressFragmentToCheckoutShippingAddressInput, convertShippingAddressInputToShippingAddressFragment, emptyShippingAddress, convertCartShippingAddressToCheckoutShippingAddressInput } from 'Utils/helpers/addressHelper'
import CheckoutHelper from 'Utils/helpers/checkoutHelper'
import { showMessage } from 'Utils/helpers/modalHelper'
import animateScrollTo from 'animated-scroll-to'
import { SCROLL_OPTIONS } from 'Utils/helpers/misc'
import Checkbox from 'Components/Checkbox'
import Markdown from 'react-markdown'
import get from 'lodash/get';
import Redirect from 'Components/Redirect';
import DeliveryDiscount from 'Components/Cart/DeliveryDiscount';
import PageLink from 'Components/PageLink';
import { CheckoutStage } from 'Utils/helpers/constants';

type ReduxProps = {
  orderData: Redux.IOrderData
  checkoutInfo: Redux.ICheckoutInfo
  deliveryAddress: Redux.IDeliveryAddress | undefined
  cart: CartFragment | null
  session: Redux.IStoreSessionData
}

type PropType = {
  isFetching: boolean
  onGoToBilling: (newCart: CartFragment) => void
} & ReduxProps & DispatchProp

type StateType = {
  isFetching: boolean
  shipping_address: CartShippingAddressInput
  timeslot_id: string | null
  errors: Redux.IFormErrors<ShippingAddressFragment>
  saveAddress: boolean
}

export function isTimeTableData(x: ShippingMethodFragment_ShippingMethodGRoby_data | null): x is ShippingMethodFragment_ShippingMethodGRoby_data {
  return x != null
}

class DeliveryGroby extends React.Component<PropType, StateType> {
  container: HTMLDivElement | null = null
  
  
  constructor(props: PropType) {
    super(props)
    
    let shipping_address: CartShippingAddressInput = convertShippingAddressFragmentToCheckoutShippingAddressInput(emptyShippingAddress())
    if (this.props.cart && this.props.deliveryAddress) {
      if (this.props.cart.shipping_address) {
        shipping_address = convertCartShippingAddressToCheckoutShippingAddressInput({...this.props.cart.shipping_address, postcode: this.props.deliveryAddress && this.props.deliveryAddress.value.zip || ''})
      } else if (this.props.cart.contact_data) {
        const cd = this.props.cart.contact_data
        shipping_address = convertShippingAddressFragmentToCheckoutShippingAddressInput(
          emptyShippingAddress({
            postcode: this.props.deliveryAddress && this.props.deliveryAddress.value.zip || undefined,
            name: cd.contact_name,
            telephone: cd.contact_telephone
          })
        )
      }
    }
    
    
    this.state = {
      isFetching: false,
      shipping_address,
      timeslot_id: get(this.props, 'cart.timetable_time_slot.id', null),
      saveAddress: true,
      errors: noError()
    }
  }

  shippingAddressChangeHandler = (shipping_address: ShippingAddressFragment) => {
    this.setState({ shipping_address: convertShippingAddressFragmentToCheckoutShippingAddressInput(shipping_address) })
  }

  handleSlotChange = (slot: string | null) => {
    this.setState({ timeslot_id: slot })
  }

  goToBilling = async () => {
    const { cart } = this.props
    this.setState({ isFetching: true })
    if (!cart || !cart.shipping_method) {
      return
    }

    try {
      const validation = validateForm(this.state.shipping_address, ['city', 'house_number', 'name', 'postcode', 'street', 'telephone', 'name'])
      if (hasErrors(validation)) {
        throw validation
      }

      const method = cart.shipping_method
      if (!method) {
        showMessage('no shipping method selected or no cart')
        return
      }

      if (method.__typename === 'ShippingMethodGRoby' && !this.state.timeslot_id) {
        showMessage('Kérünk, válassz ki egy kiszállítási időpontot!')
        return
      }

      const result = await _app.apolloClient.mutate<updateCart, updateCartVariables>({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: cart.id,
            shipping_address: this.state.shipping_address,
            timetable_time_slot_id: method.__typename === 'ShippingMethodGRoby'
              ? Number(this.state.timeslot_id)
              : undefined
          }
        }
      })

      if (result.data && result.data.updateCart) {
        this.props.dispatch(setCart(result.data.updateCart))
        this.props.onGoToBilling(result.data.updateCart)
      } else throw new Error('No data received')
    } catch (e) {
      const shippingAddressErrors = parseErrors<ShippingAddressFragment>(e, 'shipping_address')
      if (hasFieldErrors(shippingAddressErrors)) {
        this.setState({ errors: shippingAddressErrors })
        showMessage('A megadott szállítási adatok hibásak! Kérünk, ellenőrizd le, mindent jól adtál-e meg!')
        animateScrollTo(this.container || 0, SCROLL_OPTIONS)
      } else {
        const errorMessages = collectAllErrorsForModal(e)
        showMessage(<>Hiba történt: {errorMessages}</>)
      }
    } finally {
      this.setState({ isFetching: false })
    }
  }

  render() {
    if (!this.props.cart || !this.props.cart.shipping_method) {
      return <Redirect to="/kosar" />
    }
    
    const { cart, cart: { shipping_method }, checkoutInfo: { shippingMethods } } = this.props

    const grobyMethod = shippingMethods.find(sm => sm.__typename === 'ShippingMethodGRoby') as getCheckoutInfo_shippingMethods_ShippingMethodGRoby | undefined
    const timeTableEntries = grobyMethod && grobyMethod.data.filter(isTimeTableData) || []
    const btnDisabled = this.props.isFetching || this.state.isFetching
    const hasGiftBasket = cart.cart_products.some(cp => cp.product.gift_message_available)

    return (
      <div className={cl.deliveryGroby} ref={ref => this.container = ref}>
        <div className={cn(chk.checkoutPage__headerContainer, cl.checkoutPage__headerContainer)}>
          <h2 className={chk.h2}>Szállítási adatok</h2>
        </div>

        <div className={chk.checkoutPage__bodyContainer}>
          <ShippingAddressForm
            fieldsOnly
            postCodeDisabled
            address={convertShippingAddressInputToShippingAddressFragment(this.state.shipping_address)}
            onChange={this.shippingAddressChangeHandler}
            errors={this.state.errors}
          />
        </div>
        
        {this.props.session.loggedIn &&
          <Checkbox
            label="Szállítási adatok mentése"
            name="saveAddress"
            checked={this.props.orderData.save_shipping_address}
            onChange={() => { this.props.dispatch(updateOrder({ save_shipping_address: !this.props.orderData.save_shipping_address })) }}
          />
        }

        {shipping_method.__typename === 'ShippingMethodGRoby' &&
          <>
            <div className={cn(chk.checkoutPage__headerContainer, cl.checkoutPage__headerContainer)}>
              <h2 className={chk.h2}>Kiszállítás időpontja</h2>
            </div>

            {hasGiftBasket && <DeliveryDiscount hasGiftBasket={hasGiftBasket} remaining={0} />}

            <Calendar
              timeTableEntries={timeTableEntries}
              selectedSlotId={this.state.timeslot_id}
              onChange={this.handleSlotChange}
            />
          </>
        }

        {shipping_method.__typename === 'ShippingMethodMpl' &&
          <>
            <div className={cn(chk.checkoutPage__headerContainer, cl.checkoutPage__headerContainer)}>
              <h2 className={chk.h2}>Kiszállítás időpontja</h2>
            </div>

            <div className={cn(chk.checkoutPage__bodyContainer, cl.deliveryPostaPont__deliveryInfo)}>
              <Markdown source={shipping_method.delivery_time || ''} />
            </div>
          </>
        }

        <div className={cn(chk.checkoutPage__buttonContainer)}>
          <div className={cn(cg.gridX, cg.gridMarginX)}>
            <div className={cn(cg.cell, cg.medium6)}>
              <PageLink toPage="/megrendeles" className={cn(btnCss.button, btnCss.hollow, cl.buttonLink, btnCss.mobileExpanded)}>
                {CheckoutHelper.getPreviousCheckoutButtonText(CheckoutStage.SHIPPING, this.props)}
              </PageLink>
            </div>
            <div className={cn(cg.cell, cg.medium6, cg.mediumTextRight)}>
              <Button label={CheckoutHelper.getNextCheckoutButtonText(CheckoutStage.SHIPPING, this.props)} className={cn(btnCss.mobileExpanded)} onClick={this.goToBilling} disabled={btnDisabled} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect<ReduxProps, {}, {}, Redux.IReduxState>(({ orderData, checkoutInfo, deliveryAddress, cart, session }) => ({
  orderData,
  checkoutInfo,
  deliveryAddress,
  session,
  cart
}))(DeliveryGroby)
